import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className='overlay open'>    
        <div className="spinner" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  );
};

export default LoadingSpinner;